import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
	state: () => ({
		user: null
	}),

	getters: {
		getUser: (state) => state.user,
	},
	actions: {
		setUser(data) {
			this.user = data;
		},

		logoutUser() {
			setTimeout(() => this.user = null, 0)
		},
	},
})